export { default as NominasList } from './Listar';
export { default as NominaCrear } from './Crear'
